import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';
import { initServerSideDataTable, escapeHtml } from '../src/server_side_datatable';

export default class extends Controller {
  static targets = [
    'style_vendor',
    'color',
    'size',
    'category',
    'editPocItemDetailModal',
    'addPocItemDetailModal',
    'confirmDeleteModal',
    'skuTable',
  ];

  initialize() {
    this.initialDataTablesSku();
    this.initialDataTablesPocInhouse();
    this.showImportError();
  }

  change(event) {
    const style_vendor =
      event.target.selectedOptions[0].getAttribute('style_vendor');
    const color = event.target.selectedOptions[0].getAttribute('color');
    const size = event.target.selectedOptions[0].getAttribute('size');
    const category = event.target.selectedOptions[0].getAttribute('category');
    this.poc(style_vendor, color, size, category);
  }

  poc(style, color, size, category) {
    this.style_vendorTarget.value = style;
    this.colorTarget.value = color;
    this.sizeTarget.value = size;
    this.categoryTarget.value = category;
  }

  confirmDelete(e) {
    e.preventDefault();

    const modal = $(this.confirmDeleteModalTarget);
    modal.find('.delete').attr('href', e.params.url);
    modal.find('.sku').text(e.params.sku);
    this.myModal(this.editPocItemDetailModalTarget).hide();
    this.myModal(this.confirmDeleteModalTarget).show();
  }

  cancelDelete() {
    this.myModal(this.editPocItemDetailModalTarget).show();
  }

  openEditPocItemDetailModal(e) {
    e.preventDefault();

    const frame =
      this.editPocItemDetailModalTarget.querySelector('turbo-frame');
    frame.id = e.params.dom;
    frame.src = e.params.url;
    this.myModal(this.editPocItemDetailModalTarget).show();
  }

  openAddPocItemDetailModal(e) {
    e.preventDefault();
    const frame = this.addPocItemDetailModalTarget.querySelector('turbo-frame');
    frame.src = e.params.url;
    this.myModal(this.addPocItemDetailModalTarget).show();
  }

  toggleEditValue(e) {
    const id = e.params.id;
    const element = $(`#newQty-${id}`);

    element.prop('disabled', !element.prop('disabled'));
  }

  setQty(e) {
    const id = e.params.id;
    let stockQty = parseInt(document.getElementById(`stockQty-${id}`).value);
    stockQty = stockQty > 0 ? stockQty : 0;
    const newQty = parseInt(e.target.value);
    const needQty = parseInt(document.getElementById(`needQty-${id}`).value);

    if (newQty >= needQty - stockQty) {
      $(`[name="product-detail"][id="${id}"]`)
        .find('input[name="poc[item_details_attributes][][qty]"]')
        .val(newQty);
    }
  }

  myModal(element) {
    return (
      bootstrap.Modal.getInstance(element) ||
      new bootstrap.Modal(element, { keyboard: false })
    );
  }

  // SKU list on the POC edit page, rows come from ItemDetailsController#index (JSON).
  initialDataTablesSku() {
    if (!this.hasSkuTableTarget) {
      return;
    }

    initServerSideDataTable(this.skuTableTarget, {
      renderers: {
        edit: (row) => `
          <a href="#" data-action="click->poc#openEditPocItemDetailModal"
             data-poc-dom-param="${escapeHtml(row.dom_id)}"
             data-poc-url-param="${escapeHtml(row.edit_url)}">
            <i class="fal fa-edit color-blue"></i>
          </a>`,
      },
    });
  }

  initialDataTablesPocInhouse() {
    const table = 'table#pocInhouseTable';

    if (!$(table).length) {
      return;
    }

    if (!$.fn.DataTable.isDataTable(table)) {
      $(table).dataTable({
        columnDefs: [{ orderable: false, targets: 'nosort' }],
        order: [],
      });
    }

    document.addEventListener('turbo:before-cache', () => {
      const table = $('table#pocInhouseTable');

      if (!table.length) {
        return;
      }

      const tableConstant = table.DataTable();
      tableConstant.destroy();
    });
  }

  showImportError() {
    try {
      const message = document.getElementById('import-error').dataset.message;
      if (message) {
        this.myModal($('#template-error')).show();
      }
    } catch (e) {
      // Do nothing
    }
  }

  toggleSelectAllPocInhouse(e) {
    const isChecked = e.target.checked;
    const table = $('table#pocInhouseTable').DataTable();
    const rows = table.rows({ search: 'applied' }).nodes();

    rows.each((element, _) => {
      const id = element.id;
      const qtyInput = $(rows).find(`#newQty-${id}`);
      const checkbox = $(rows).find(`input[type="checkbox"][data-id="${id}"]`);
      const destroyInput = $(
        `div#${id} input[name="poc[item_details_attributes][][_destroy]"]`,
      );

      qtyInput.prop('disabled', !isChecked);
      checkbox.prop('checked', isChecked);
      destroyInput.val(!isChecked);
    });
  }

  toggleSelectPocInhouse(e) {
    const isChecked = e.target.checked;
    const id = $(e.currentTarget).data('id');

    const qtyInput = $(`#newQty-${id}`);
    const destroyInput = $(
      `div[id="${id}"] input[name="poc[item_details_attributes][][_destroy]"]`,
    );

    qtyInput.prop('disabled', !isChecked);
    destroyInput.val(!isChecked);
  }

  submitFormInhouse() {
    const form = document.getElementById('form-poc-inhouse');
    if (form.checkValidity()) {
      this.openSpinner();
      form.requestSubmit();
    } else {
      form.reportValidity();
    }
  }

  openSpinner() {
    $('.overlay').addClass('show');
    $('.spanner').addClass('show');
  }
}
